var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-wrap", class: _vm.alignmentClass },
    [
      _vm.noContent
        ? _c("div", { staticClass: "text-sm font-semibold" }, [_vm._v("n/a")])
        : _vm._e(),
      _vm._l(_vm.contractorsToRender, function (contractor) {
        return _c(
          "EmployeeRemovedFromCompanyTooltip",
          { key: contractor.id, attrs: { disabled: !contractor.deleted } },
          [
            _c(
              "ItemChip",
              {
                attrs: {
                  itemId: contractor.id,
                  itemName: contractor.name,
                  avatar: contractor.avatar,
                  routeName: _vm.getContractorRoute(contractor.routeName),
                  removed: contractor.deleted,
                  isPerson: "",
                },
              },
              [
                _vm.isActivityExist(contractor.activityCount)
                  ? _c("span", { staticClass: "truncate" }, [
                      _vm._v(
                        " " +
                          _vm._s(contractor.name) +
                          " (" +
                          _vm._s(contractor.activityCount) +
                          ") "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          1
        )
      }),
      _vm.contractorsMoreThanLimit
        ? _c(
            "div",
            { staticClass: "ml-2 inline-block" },
            [
              _vm.navigateTo
                ? [
                    _c("RouterLink", { attrs: { to: _vm.navigateTo } }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "truncate text-primary-500 cursor-pointer",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.contractors.length - _vm.limit) +
                              " more... "
                          ),
                        ]
                      ),
                    ]),
                  ]
                : [
                    _c("span", { staticClass: "truncate" }, [
                      _vm._v(
                        _vm._s(_vm.contractors.length - _vm.limit) +
                          " moriiii..."
                      ),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }